import { AuthApi } from "@/api/index";
import _ from "lodash";

const state = {
  menuData: [],
  authSet: [],
  isCollapse: false,
  userInfo: {}
};

const getters = {
  getMenuDataSort: state => {
    let menuData = state.menuData.map(item => {
      item.children = _.orderBy(item.children, ["sort"], ["asc"]);
      return item;
    });
    let newMenuData = _.orderBy(menuData, ["sort"], ["asc"]);
    return newMenuData;
  },
  getAuthData: state => {
    return state.authSet;
  }
};

const mutations = {
  isCollapseChange(state) {
    state.isCollapse = !state.isCollapse;
  },
  setMenuData(state, data) {
    state.menuData = data;
  },
  setAuthData(state, data) {
    state.authSet = data;
  },

  //存储用户基本信息
  setUserInfo(state, data) {
    state.userInfo = data;
  }
};

const actions = {
  toggleSideBar: ({ commit }) => {
    commit("isCollapseChange");
  },
  getMenuData: async ({ commit }) => {
    let resAuth = await AuthApi(); //获取菜单
    if (resAuth && resAuth.code == 0) {
      console.log(resAuth);
      commit("setMenuData", resAuth.data);
      return "success";
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
